import HomePageLayout from 'global/HomePageLayout';
import SEO from 'global/SEO';
import Text from '@deprecated-ui/common/Text';
import Image from 'global/Image';
import { assetPrefix } from 'constants/app';
import {
  Title,
  MiniTitle,
  Container,
  TataKelolaHeader,
  ImageTitle,
  Item,
  Paragraph,
  UnorderList,
  WhistleContainer,
  WhistleText,
  DownloadContainer,
  DownloadButton,
} from './styled';

const GuestAbout = () => (
  <HomePageLayout hideStartInvesting>
    <SEO title="Tata Kelola | Stockbit - Komunitas Saham Indonesia" />
    <TataKelolaHeader>
      <Image src="/images/tatakelola-header.svg" alt="tatakelolaheader" />
      <ImageTitle>Tata Kelola Perusahaan</ImageTitle>
    </TataKelolaHeader>
    <Container>
      <Item>
        {/* @ts-expect-error */}
        <Title>Pedoman Kerja Direksi dan Dewan Komisaris</Title>
        {/* @ts-expect-error */}
        <Paragraph>
          Direksi & Dewan Komisaris masing-masing memiliki peranan penting dalam
          memastikan keberlangsungan perusahaan dengan cara menjalankan visi &
          misi dengan perspektif yang sama, termasuk dalam menegakan
          prinsip-prinsip Tata Kelola Perusahaan yang Baik sesuai dengan
          peraturan perundang-undangan yang berlaku. Untuk mendukung hal ini,
          Perusahaan memiliki pedoman kerja (charter) yang digunakan sebagai
          dasar arahan kerja Direksi & Dewan Komisaris dimana berisi antara
          lain; tugas & tanggung jawab, kewajiban, serta larangan bagi seluruh
          Dewan Komisaris & Direksi perusahaan.
        </Paragraph>
      </Item>
      <Item>
        {/* @ts-expect-error */}
        <Title>Kode Etik</Title>
        {/* @ts-expect-error */}
        <Paragraph>
          Perusahaan menyadari pentingnya untuk melakukan penyusunan Kebijakan
          Etika Perusahaan yang selanjutnya disebut “Code of Conduct” atau
          “COC”. COC merupakan sekumpulan komitmen yang terdiri dari etika
          bisnis Perusahaan dan etika kerja Karyawan Perusahaan yang disusun
          untuk membentuk, mengatur dan melakukan kesesuaian tingkah laku
          seluruh Karyawan termasuk Direksi & Dewan Komisaris sehingga tercapai
          keluaran yang konsisten yang sesuai dengan budaya Perusahaan dalam
          mencapai visi dan misinya.
          <span>
            Kode etik disusun oleh Direksi dan Dewan Komisaris, paling sedikit
            memuat:
          </span>
          <UnorderList>
            <li>Nilai perusahaan;</li>
            <li>
              Prinsip pelaksanaan tugas direksi, Dewan Komisaris,
              karyawan/pegawai, dan/atau pendukung organ yang dimiliki
              Perusahaan Efek yang dilakukan dengan itikad baik, penuh tanggung
              jawab dan kehati-hatian;
            </li>
            <li>Kebijakan Perusahaan Efek terkait benturan kepentingan;</li>
            <li>Penangan pelanggaran kode etik; dan</li>
            <li>Akuntabilitas pengenaan sanksi pelanggaran kode etik.</li>
          </UnorderList>
          Stakeholders Perusahaan selain harus mengikuti peraturan dan
          perundangan yang berlaku juga harus menjunjung tinggi norma dan nilai
          etika. Kesadaran untuk menjalankan etika yang baik akan meningkatkan
          dan menciptakan budaya yang positif di Perusahaan. Dalam melakukan
          penyusunan COC ini, Perusahaan selalu memperhatikan hukum dan
          ketentuan yang berlaku, visi, misi, tujuan, dan nilai‐nilai yang
          dianut oleh Perusahaan.
        </Paragraph>
      </Item>
      <Item>
        {/* @ts-expect-error */}
        <Title>Fungsi dan Kebijakan Manajemen Risiko</Title>
        {/* @ts-expect-error */}
        <Paragraph>
          Fungsi Manajemen Risiko merupakan fungsi yang memiliki tanggung jawab
          secara langsung kepada Direktur Utama yang antara lain memiliki ruang
          lingkup sebagai berikut:
          <UnorderList>
            <li>
              Memberikan masukan kepada Direksi antara lain dalam penyusunan
              kebijakan Manajemen Risiko;
            </li>
            <li>
              Memantau pelaksanaan kebijakan Manajemen Risiko dan pengendalian
              Risiko;
            </li>
            <li>Melakukan pemantauan Risiko berdasarkan hasil penilaian:</li>
            <li>Melakukan Pemantauan Transaksi Bursa;</li>
            <li>
              Menetapkan sistem manajemen risiko yang akan digunakan dalam
              pengelolaan risiko usaha Perusahaan;
            </li>
            <li>
              Melakukan pemantauan, identifikasi, pengukuran dan tindakan lanjut
              terkait hal yang berhubungan dengan manajemen risiko yang
              memerlukan perhatian Direksi.
            </li>
            <li>
              Menyusun dan memastikan pelaksanaan parameter batasan transaksi
              baik untuk kepentingan nasabah maupun kepentingan Perusahaan.
            </li>
          </UnorderList>
        </Paragraph>
      </Item>
      <Item>
        {/* @ts-expect-error */}
        <Title>Fungsi dan Kebijakan Kepatuhan dan Audit Internal</Title>
        <MiniTitle>Kepatuhan</MiniTitle>
        {/* @ts-expect-error */}
        <Paragraph mb="4px">
          Fungsi Kepatuhan Perusahaan merupakan fungsi yang independen dimana
          secara garis besar ruang lingkupnya mencakup:
          <UnorderList>
            <li>
              Memantau & memastikan bahwa seluruh aspek yang berkaitan dengan
              perusahaan sudah berjalan sesuai dengan peraturan
              perundang-undangan yang berlaku.
            </li>
            <li>
              Melakukan identifikasi, evaluasi & tindak lanjut terhadap seluruh
              aspek yang berkaitan dengan kepatuhan terhadap peraturan yang
              berlaku.
            </li>
            <li>
              Melakukan pelaporan terhadap pihak yang berkepentingan sesuai
              dengan peraturan yang berlaku.
            </li>
          </UnorderList>
        </Paragraph>

        <MiniTitle>Audit Internal</MiniTitle>
        {/* @ts-expect-error */}
        <Paragraph>
          Fungsi Audit Internal Perusahaan memiliki ruang lingkup sebagai
          berikut:
          <UnorderList>
            <li>Menyusun dan melaksanakan rencana Audit Internal Tahunan.</li>
            <li>
              Menguji dan mengevaluasi pelaksanaan pengendalian internal dan
              sistem manajemen risiko sesuai dengan kebijakan Perusahaan.
            </li>
            <li>
              Melakukan pemeriksaan efektivitas di bidang keuangan, akuntansi,
              operasional, kepatuhan, sumber daya manusia, pemasaran dan
              kegiatan lainnya.
            </li>
            <li>
              Memberikan saran perbaikan dan informasi yang objektif tentang
              kegiatan yang diperiksa pada semua tingkat manajemen.
            </li>
            <li>
              Membuat laporan hasil audit dan menyampaikan laporan tersebut
              kepada Direksi dan Dewan Komisaris.
            </li>
            <li>
              Memantau, menganalisis dan melaporkan pelaksanaan tindak lanjut
              perbaikan yang disarankan.
            </li>
            <li>Bekerja sama dengan Komite Audit.</li>
            <li>Melakukan pemeriksaan khusus apabila diperlukan.</li>
          </UnorderList>
        </Paragraph>
      </Item>

      <a href="mailto:compliance@stockbit.com">
        <WhistleContainer>
          <Image src="/images/whistle_icon.svg" />
          <WhistleText>
            <Text as="p" size="16px" family="bold">
              Pelaporan Pelanggaran (Whistle Blower):
            </Text>
            <Text as="p" size="16px">
              compliance@stockbit.com
            </Text>
          </WhistleText>
        </WhistleContainer>
      </a>

      <DownloadContainer>
        <DownloadButton
          href={`${assetPrefix}/pdf/laporan-keuangan-2023.pdf`}
          target="_blank"
          download
        >
          <Image src="/images/download.svg" />
          Laporan Keuangan
        </DownloadButton>
        <DownloadButton
          href={`${assetPrefix}/pdf/RUPS.pdf`}
          target="_blank"
          download
        >
          <Image src="/images/download.svg" />
          RUPS
        </DownloadButton>
      </DownloadContainer>
    </Container>
  </HomePageLayout>
);

export default GuestAbout;
